import * as types from './types'

/**
 * @author: lwq
 * @function: 设置特价活动属性值
 * @param  data {object} 请求参数
 * @return: {object}
 */
export const setSpecialActiveInfo = ({ commit }, specialPriceActiveInfo) => {
  commit(types.SET_ALL_ACTIVIRY, specialPriceActiveInfo)
}

/**
 * @author: lwq
 * @function: 设置特价活动对象值为空
 * @param  data {object} 请求参数
 * @return: {object}
 */
export const emptySpecialActiveInfo = ({ commit }) => {
  commit(types.EMPTY_ALL_ACTIVIRY)
}

/**
 * 添加的特价商品
 * @param {*} param0
 * @param {*} data
 */
export const saveSpecialOffersInfo = ({ commit }, data) => {
  commit(types.SPECIAL_OFFERS, data)
}
